export default "__VITE_ASSET__qBqE15Bj__"